<template>
  <div class="ev-menu-container">
    <template v-for="route in routeFiltered">
      <router-link
        :key="route.routeName"
        :to="{'name' : route.routeName}"
        class="ev-menu-link flex flex-column items-center justify-center"
        :class="{
          'router-link-active--is-ccpm': isCcpm,
        }"
      >
        <i
          class="menu-link__icon"
          :class="route.icon"
        />
        <span class="menu-link__text">
          {{ route.name }}
        </span>
      </router-link>
    </template>
  </div>
</template>

<style lang="scss" scoped>
  .ev-menu-link {
  padding: 0 0 25px 0;

  &.router-link-active {
    .menu-link__text {
      opacity: 1;
    }
  }
}

.ev-menu-container {
  padding: 0 10px 0 10px;
}

.menu-link__text {
  visibility: visible;
  opacity: .8;
}

</style>

<script>
import { mapState, mapGetters } from 'vuex';
import apis from '@/apis';
import { MARKETPLACE } from '../Constants/MenusConstants';

export default {
  name: 'Menu',
  data() {
    return {
      isCcpm: true,
      hasMarketPlaceRight: null,
      menuTab: [
        {
          routeName: 'Page-TableauDeBord',
          name: 'Tableau de bord',
          icon: 'even-icon-dashboard',
        },
        {
          routeName: 'Page-Operations',
          name: 'Opérations',
          icon: 'even-icon-operation',
        },
        {
          routeName: 'Page-CoffreFort',
          name: 'Coffre Fort',
          icon: 'even-icon-coffre-fort',
        },
        // Selon le ticket JIRA : feature/CA-1959-pwa-changement-menu-pwa
        // "Repousser le développement de ces pages pour la partie mobile"
        // {
        //   routeName: 'Page-Aide',
        //   name: 'Aide',
        //   icon: 'even-icon-bold-question',
        // },
        {
          routeName: 'Page-Marketplace',
          name: 'Marketplace',
          icon: 'even-icon-shopping-cart',
        },
        {
          routeName: 'Page-Compte',
          name: 'Compte',
          icon: 'even-icon-profil',
        },
      ],
    };
  },
  computed: {
    ...mapState(['featureFlags']),
    ...mapGetters(['userConnected']),
    routeFiltered() {
      if (!this.hasAccessToMarketplace()) {
        return this.menuTab.filter((menuItem) => menuItem.name !== 'Marketplace');
      }
      return this.menuTab;
    },
  },
  beforeCreate() {
    apis.User.getModulesAccessibility().then((modulesAccessibility) => {
      this.hasMarketPlaceRight = modulesAccessibility.modulesVisible.includes(MARKETPLACE.id);
    });
  },
  methods: {
    hasAccessToMarketplace() {
      return this.hasMarketPlaceRight;
    },
  },
};
</script>
